import {useFarm} from 'context/farmContext';
import SimpleForm from './simple';
import AuctionForm from './auction';
import SaleForm from './sale';
import PrePaymentForm from './prepayment';
import {toast} from 'react-toastify';
import {useEffect} from 'react';
import {useCookies} from 'react-cookie';

const FormOwnerInfo = () => {
  const {farm} = useFarm();
  const [, , removeCookie] = useCookies(['cultivationGuid']);
  useEffect(() => {
    removeCookie('cultivationGuid', {
      path: '/',
      domain: 'mazraeapp.com',
    });
  }, []);
  switch (farm?.type) {
    case 'simple':
      return <SimpleForm />;
    case 'auction':
      return <AuctionForm />;
    case 'sale':
      return <SaleForm />;
    case 'prepayment':
      return <PrePaymentForm />;
    default:
      toast.error('لطفا نوع آگهی را انتخاب کنید');
      return <></>;
  }
};

export default FormOwnerInfo;
